module.exports = __webpack_public_path__ + "static/media/playerReady.9185d2e0.mp3";